import {Component, Inject, OnInit} from '@angular/core';
import {UntilDestroy} from '@ngneat/until-destroy';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {
  Application,
  AssetConditionType,
  BrokerageSelectionType,
  BrokerageSelectionValue,
  BrokerageSelectionValueOptions,
  calculateAssetFinanceEstimation,
  calculateBusinessLoanEstimation,
  calculateBusinessOverdraftFees,
  ContractTemplateData,
  DeleteContractFileFn,
  DocusignSigner,
  FinanceType,
  GenerateContractDialogData,
  GenerateContractDialogResult,
  GenerateContractFn,
  GenerateContractResponse,
  GetApplicationindividualsPayload,
  IndividualWithResult,
  LoanTermType,
  LoanTermValue,
  parseJSON,
  PaymentFrequencyType,
  PaymentFrequencyValue,
  PaymentFrequencyValueOptions,
  PpsrAsset,
  RatecardDetails,
  SendContractEmailsFn,
  SendContractResponse,
  User,
  yesNoToBoolean,
  applicantOf,
  individualSignerRole,
  individualSignedGuaranteeRoles,
  ApplicationIndividual,
  getAbn,
  getAcn,
  getCorporateTrusteeOf,
  getAdverseOnFile,
  getApplicationName,
  getAssetCategoryObj,
  getAssetCondition,
  getAssetType,
  getAssetTypeObj,
  getAssetYear,
  getBalloonPaymentPercentage,
  getBrokerName,
  getCompanyName,
  getEquifaxScoreAboveThresold,
  getExpense,
  getFinanceType,
  getLoanAmount,
  getBrokerageAmount,
  getBrokerage,
  getPropertyOwner,
  getApplicationAssetCategory,
  getAdditionalSecurity,
  Contact,
  AssetSettlementGetApplicationAssetFn,
  DigitalIdGetApplicationIndividualsFn,
  GetRateCardDetailsFn,
  EditAddressDialogResult,
  Address2ComponentValue,
  getPrimaryBusinessAddressObject,
  SyncContractDetailsToSfFn,
  getAppSalesforceId,
  SyncContractDetailsBody,
  Individual,
  getPaymentType, getContractFileName, getApplicationCustomerName,
  getSpecialConditions, ContractEmailBody, removeUnprintableChar, TransactionValue,
  PrivateSaleType,
  GetAccountDetailsFromSfFn,
  SfAccountDetails,
  UpdateApplicationFn,
  booleanToYesNo,
  ContractPricingDetails,
  isExternalUser,
  getCreditRateAdjustment,
  getRbaRate,
  getDocFee, validateAssetDepositAgainstApplicationDeposit, CalculateBusinessOverdraftEstimationResult,
  GetOriginatorBusinessByIdFn,
  getRepaymentType,
  isAdminOrCreditOrOperationsOrSalesUser,
  ASSET_FINANCE_BROKERAGE_UPLIFT_TIER1_PERCENT,
  EditBrokerageDialogResult,
  assetFinanceBrokerageBasis,
  brokerageAmountFromPercent,
  brokerageExceedsMax,
  brokerageExceedsMaxMessage,
  maxBrokerageAmount,
  maxBrokeragePercent,
} from '@portal-workspace/grow-shared-library';
import { FormBuilder, FormControl, FormGroup, ValidatorFn, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ApplicationDialogService,
  applicationToAdverseOnFile,
  applicationToAsset,
  applicationToBrokerOriginationFee,
  applicationToDepositAmount,
  applicationToDirectorScore,
  applicationToDocFee,
  applicationToEquifaxDirectorScoreMeetsThreshold,
  applicationToEquifaxScoreAboveThreshold,
  applicationToFacilityEstablishmentFee,
  applicationToGstAgeMonths,
  applicationToGstAgeMonthsWithContinuity,
  applicationToFacilityEstablishmentFeePercent,
  applicationToInterestRate,
  applicationToInvoiceAmount,
  applicationToLoanTerms,
  applicationToPaymentFrequency,
  applicationToPrivateSales,
  applicationToPropertyOwner,
  applicationToTransactionValue,
  PortalHotToastService,
  setPrevNextButtonVisibilityFn,
  setSecondaryButtonFn,
  setSecondaryButtonText,
  setupUntilDestroy,
  validateEmail,
  createAbnInputMask,
  createAcnInputMask,
  checkContractIndividuals,
  formControlErrorKeys,
  formControlErrorMessage,
  applicationToDocFeeFinanced,
  getUser,
  applicationToMargin,
  setStepper2StepConfig,
  applicationToAbnAgeAboveThresholdOverride,
  applicationToTermRenewal,
  applicationToAdditionalCommission,
  httpOptions,
} from '@portal-workspace/grow-ui-library';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MessageBoxComponent} from '../message-box/message-box.component';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import {Sort} from '@angular/material/sort';
import {CollectionViewer, DataSource, SelectionModel} from '@angular/cdk/collections';
import {BehaviorSubject, combineLatest, Observable, Subscription} from 'rxjs';
import moment from 'moment';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { LooseCurrencyPipe } from '../../pipes/loose-currency.pipe';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatTableModule } from '@angular/material/table';
import { InputMaskModule } from '@ngneat/input-mask';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexModule } from '@angular/flex-layout/flex';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgTemplateOutlet, DecimalPipe, NgClass } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { ApplicationStepper2Component } from '../application-stepper-component/application-stepper2.component';
import _ from 'lodash';
import {PercentagePipe} from '../../pipes/percentage.pipe';
import {SignerRolePipe} from '../../pipes/signer-role.pipe';
import numeral from 'numeral';
export class InternalDataSource extends DataSource<IndividualWithResult> {

  subject = new BehaviorSubject<IndividualWithResult[]>([]);

  connect(collectionViewer: CollectionViewer): Observable<IndividualWithResult[]> {
    return this.subject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.subject.complete();
  }

  update(users: IndividualWithResult[]) {
    this.subject.next(users);
  }

}

@UntilDestroy({ arrayName: 'subscriptions' })
@Component({
    templateUrl: './generate-contract.dialog.html',
    styleUrls: ['./generate-contract.dialog.scss'],
    standalone: true,
  imports: [
    ApplicationStepper2Component,
    MatSelectModule,
    CdkStepperModule,
    NgTemplateOutlet,
    FormsModule,
    ReactiveFormsModule,
    FlexModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    InputMaskModule,
    MatTableModule,
    MatCheckboxModule,
    MatChipsModule,
    PdfViewerModule,
    DecimalPipe,
    LooseCurrencyPipe,
    NgClass,
    MatDialogModule,
    MessageBoxComponent,
    PercentagePipe,
    SignerRolePipe
]
})
export class GenerateContractDialog implements OnInit {
  sendContractEmailsFn!: SendContractEmailsFn;
  getRatecardDetailsFn!: GetRateCardDetailsFn;
  getApplicationIndividualsFn!: DigitalIdGetApplicationIndividualsFn;
  generateContractFn!: GenerateContractFn;
  getApplicationAssetFn!: AssetSettlementGetApplicationAssetFn;
  deleteContractFileFn!: DeleteContractFileFn;
  syncContractDetailsToSfFn!: SyncContractDetailsToSfFn;
  errorKeys = formControlErrorKeys;
  errorMessage = formControlErrorMessage;
  getAccountDetailsFromSfFn!: GetAccountDetailsFromSfFn;
  updateApplicationFn!: UpdateApplicationFn;
  getOriginatorBusinessByIdFn!: GetOriginatorBusinessByIdFn;

  depositValidationMessage: string | null = null;
  rateCard!: RatecardDetails;

  application!: Application;
  subscriptions: Subscription[] = [];
  primaryContact!: Contact | ApplicationIndividual | null;
  compareWithRepaymentFrequencyFn: (option: PaymentFrequencyValue, selected: PaymentFrequencyValue) => boolean = (option, selected) => {
    return (!!option && !!selected && option.type === selected.type);
  };

  // step 1
  formGroupStep1!: FormGroup; // asset finance
  formGroupStep1BusinessLoan!: FormGroup;
  formGroupStep1BusinessOverdraft!: FormGroup;

  formControlStep1TotalInterest!: FormControl<number | null>;
  formControlStep1InvoicePrice!: FormControl<number | null>;
  formControlStep1TotalPayment!: FormControl<number | null>;
  formControlStep1PaymentInAdvanceOrArrears!: FormControl<string | null>;
  formControlStep1DocFee!: FormControl<number | null>;
  formControlStep1InterestRate!: FormControl<number | null>;
  formControlStep1DisplayedMargin!: FormControl<number | null>;
  formControlStep1Deposit!: FormControl<number | null>;
  formControlStep1LoanTerm!: FormControl<LoanTermValue | null>;
  formControlStep1Residual!: FormControl<number | null>;
  formControlStep1RepaymentFrequency!: FormControl<PaymentFrequencyValue | null>;
  formControlStep1BrokerageAmount!: FormControl<number | null>;
  formControlStep1NumberOfInstallment!: FormControl<number | null>;
  formControlStep1BrokerOriginationFee!: FormControl<number | null>;
  formControlStep1PrivateSale!: FormControl<PrivateSaleType | null>;
  formControlStep1TransactionType!: FormControl<TransactionValue | null>;
  formControlStep1Repayment!: FormControl<number | null>;
  formControlStep1AmountFinanced!: FormControl<number | null>;
  formControlStep1PropertyOwner!: FormControl<boolean | null>;
  formControlStep1AdverseOnFile!: FormControl<boolean | null>;
  formControlStep1DirectorScore!: FormControl<boolean | null>;
  formControlStep1EquifaxScoreAboveThreshold!: FormControl<boolean | null>;
  formControlStep1LoanAmount!: FormControl<number | null>;
  formControlStep1FacilityEstablishmentFeePercent!: FormControl<BrokerageSelectionValue | null>;
  formControlStep1FacilityEstablishmentFee!: FormControl<number | null>;
  formControlStep1BrokerageDollar!: FormControl<number | null>;
  formControlStep1LegalName!: FormControl<string | null>;
  formControlStep1ABN!: FormControl<string | null>;
  formControlStep1ACN!: FormControl<string | null>;
  formControlStep1Address!: FormControl<Address2ComponentValue>;
  formControlStep1Email!: FormControl<string | null>;
  formControlStep1DocFeeFinanced!: FormControl<boolean | null>;
  editInvoicePrice = false;
  editPaymentInAdvanceOrArrears = false;
  editInterestRate = false;
  editLoanTerm = false;
  editRepaymentFrequency = false;
  editBrokerage = false;
  brokeragePercent = 0;
  editBrokerOriginationFee = false;
  editLoanAmount = false;
  editLegalName = false;
  editABN = false;
  editACN = false;
  editEmail = false;
  editDeposit = false;
  editDocFeeFinanced = false;
  invoicePrice!: number | null;
  loanAmount!: number;
  PaymentFrequencyValueOptions = PaymentFrequencyValueOptions;
  BrokerageSelectionValueOptions = BrokerageSelectionValueOptions;

  // step 2
  formGroupStep2!: FormGroup;
  fromControlStep2CcEmail!: FormControl<string | null>;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  ccEmailListStep2: string[] = [];
  dataSourceStep2 = new InternalDataSource();
  protected readonly individualSignerRole = individualSignerRole;
  displayColumnsStep2 = ["fullName", "email", "mobile", "role", "primaryContact"];
  selectionStep2 = new SelectionModel<any>(true, []);
  ccEmailListStep2Error = false;
  allIndividuals: IndividualWithResult[] = [];
  contractName: string = "";
  watermarkedContractName: string = "";
  contractBase64: string = "";
  contractBuffer!: Uint8Array;
  assets: PpsrAsset[] = [];
  foundPrimaryContactIndividualStep2 = false;
  primaryContactCheckbox: boolean[] = [];
  primaryContactStep2!: IndividualWithResult;

  formGroupStep3!: FormGroup;
  apiUrl!: string;

  formGroupStep4!: FormGroup;

  setSecondaryButtonText = setSecondaryButtonText;
  setSecondaryButtonFn = setSecondaryButtonFn;
  setPrevNextButtonVisibilityFn = setPrevNextButtonVisibilityFn;

  createAbnInputMask = createAbnInputMask();
  createAcnInputMask = createAcnInputMask();
  isExternalUser = isExternalUser;
  loggedInUser: User | null = getUser();
  canEditOverdraftBrokerageOnContract = isAdminOrCreditOrOperationsOrSalesUser(this.loggedInUser);

  constructor(
    @Inject(MAT_DIALOG_DATA) data: GenerateContractDialogData,
    private dialogRef: MatDialogRef<GenerateContractDialog, GenerateContractDialogResult>,
    private formBuilder: FormBuilder,
    private toastService: PortalHotToastService,
    private applicationDialogService: ApplicationDialogService,
    private httpClient: HttpClient,
  ) {
    this.sendContractEmailsFn = data.sendContractEmailsFn;
    this.getRatecardDetailsFn = data.getRatecardDetailsFn;
    this.getApplicationIndividualsFn = data.getApplicationIndividualsFn;
    this.generateContractFn = data.generateContractFn;
    if (data?.getApplicationAssetFn) {
      this.getApplicationAssetFn = data.getApplicationAssetFn;
    }
    this.deleteContractFileFn = data.deleteContractFileFn;
    this.syncContractDetailsToSfFn = data.syncContractDetailsToSfFn;
    this.getAccountDetailsFromSfFn = data.getAccountDetailsFromSfFn;
    this.updateApplicationFn = data.updateApplicationFn;
    this.getOriginatorBusinessByIdFn = data.getOriginatorBusinessByIdFn;
    this.application = data.application;
    this.ccEmailListStep2 = [this.application.AppInfo.UserEmail];
    this.apiUrl = data.apiUrl;
    // Resolved in the constructor, which application.parties supports: the hydrator attaches it from
    // the same snapshot as the legacy arrays, so there is nothing to await.
    this.primaryContact = applicantOf(this.application.parties) ?? this.application?.Contacts
  }

  ngOnInit(): void {
    setupUntilDestroy(this);

    this.initStep1();
    this.initStep2();
    this.initStep3();
    this.initStep4();
    this.populate();
  }

  populate() {
    this.formControlStep1TotalInterest.setValue(0);/////////
    this.formControlStep1TotalPayment.setValue(0);/////////
    this.formControlStep1PaymentInAdvanceOrArrears.setValue(getPaymentType(this.application));
    this.formControlStep1Deposit.setValue(applicationToDepositAmount(this.application));
    this.formControlStep1Residual.setValue(0);/////////
    this.formControlStep1PrivateSale.setValue(applicationToPrivateSales(this.application));
    this.formControlStep1TransactionType.setValue(applicationToTransactionValue(this.application));
    this.formControlStep1Repayment.setValue(0);/////////
    this.formControlStep1AmountFinanced.setValue(0);/////////
    this.formControlStep1PropertyOwner.setValue(applicationToPropertyOwner(this.application));
    this.formControlStep1AdverseOnFile.setValue(applicationToAdverseOnFile(this.application));
    this.formControlStep1DirectorScore.setValue(applicationToDirectorScore(this.application));
    this.formControlStep1EquifaxScoreAboveThreshold.setValue(applicationToEquifaxScoreAboveThreshold(this.application));
    this.formControlStep1LoanAmount.setValue(getLoanAmount(this.application));
    this.formControlStep1FacilityEstablishmentFeePercent.setValue(applicationToFacilityEstablishmentFeePercent(this.application));
    this.formControlStep1ABN.setValue(getAbn(this.application));
    this.formControlStep1Address.setValue(getPrimaryBusinessAddressObject(this.application));
    this.formControlStep1ACN.setValue(getCorporateTrusteeOf(this.application)?.acn ?? getAcn(this.application));
    this.formControlStep1Email.setValue(this.application.Contacts?.Email!);
    this.formControlStep1DocFeeFinanced.setValue(applicationToDocFeeFinanced(this.application));

    // // invoice price
    if (this.application.ApplicationType === 'AssetFinance') {
      this.getApplicationAssets();
    }

    // rate
    this.formControlStep1InterestRate.setValue(Number(applicationToInterestRate(this.application)));

    //margin
    this.formControlStep1DisplayedMargin.setValue(applicationToMargin(this.application));

    // doc fee
    this.formControlStep1DocFee.setValue(Number(applicationToDocFee(this.application)));

    // broker origination fee
    this.formControlStep1BrokerOriginationFee.setValue(applicationToBrokerOriginationFee(this.application));
    this.formControlStep1BrokerOriginationFee.addValidators(Validators.max(applicationToBrokerOriginationFee(this.application) ?? 0));

    // brokerage: the approved % is kept, so the $ follows the loan amount when the invoice or deposit changes
    this.loanAmount = getLoanAmount(this.application);
    const approvedBrokerageAmount = getBrokerageAmount(this.application);
    // Derive the % from the approved $ rather than PricingDetails.Brokerage, which is rounded to 2dp
    // and would shift the $ by cents even when the loan amount is unchanged
    this.brokeragePercent = approvedBrokerageAmount && this.loanAmount
      ? approvedBrokerageAmount * 100 / this.loanAmount
      : getBrokerage(this.application);
    const brokerageAmount = brokerageAmountFromPercent(this.brokeragePercent, this.loanAmount);
    if (this.application.ApplicationType !== 'BusinessOverdraft') {
      this.formControlStep1BrokerageAmount.addValidators(this.brokerageMaxValidator);
    }
    this.formControlStep1BrokerageAmount.setValue(brokerageAmount);
    this.formControlStep1BrokerageDollar.setValue(brokerageAmount);
    // max validation for formControlStep1BrokerageAmount is included in getApplicationAssets() due to invoicePrice dependency
    this.formControlStep1BrokerageDollar.addValidators(Validators.max(brokerageAmount));

    // repayment
    const repaymentFrequency = applicationToPaymentFrequency(this.application);
    const loanTerm = applicationToLoanTerms(this.application);
    this.formControlStep1LoanTerm.setValue(loanTerm);
    this.formControlStep1RepaymentFrequency.setValue(repaymentFrequency);
    this.updateNumberOfInstallment(repaymentFrequency, loanTerm);

    // facility establishment fee
    this.formControlStep1FacilityEstablishmentFee.setValue(applicationToFacilityEstablishmentFee(this.application));

    // add BDM and broker to the cc list
    if (this.application.opportunityOwnerEmail) {
      this.ccEmailListStep2.push(this.application.opportunityOwnerEmail);
    }

    // get salesforce account level info
    if (this.application.AppInfo.CustomerId) {
      this.subscriptions.push(
        this.getAccountDetailsFromSfFn(this.application.AppInfo.CustomerId)
        .pipe(this.toastService.spinnerObservable())
        .subscribe((r: SfAccountDetails | null) => {
          if (r) {
            this.formControlStep1LegalName.setValue(r.Name);
          } else {
            this.formControlStep1LegalName.setValue(getCompanyName(this.application));
          }
        })
      )
    } else {
      this.formControlStep1LegalName.setValue(getCompanyName(this.application));
    }

  }

  initStep1() {
    this.formControlStep1TotalInterest = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1InvoicePrice = this.formBuilder.control(null, [Validators.required, Validators.min(0)]);
    this.formControlStep1TotalPayment = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1PaymentInAdvanceOrArrears = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1DocFee = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1InterestRate = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1Deposit = this.formBuilder.control(null, [Validators.required, Validators.min(applicationToDepositAmount(this.application) ?? 0)]);
    this.formControlStep1LoanTerm = this.formBuilder.control(null, [Validators.required]);
    // ADO 1752: the residual now follows the approved percentage against the contract invoice, so a
    // reduced invoice can produce a residual above the loan amount. That is not a financeable deal, so
    // block the step rather than generate a contract nobody can service.
    this.formControlStep1Residual = this.formBuilder.control(null, [Validators.required, Validators.min(0), (control) => {
      const residual = Number(control.value ?? 0);
      if (!residual) {
        return null;
      }
      const loanAmount = this.assetFinanceLoanAmount(this.formControlStep1InvoicePrice.value, this.formControlStep1Deposit.value);
      if (loanAmount > 0 && residual > loanAmount) {
        return {residualExceedsLoanAmount: {loanAmount}};
      }
      return null;
    }]);
    this.formControlStep1RepaymentFrequency = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1BrokerageAmount = this.formBuilder.control(null, [Validators.required, Validators.min(0)]);
    this.formControlStep1NumberOfInstallment = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1BrokerOriginationFee = this.formBuilder.control(null, [Validators.required, Validators.min(0)]);
    this.formControlStep1PrivateSale = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1TransactionType = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1Repayment = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1AmountFinanced = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1PropertyOwner = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1AdverseOnFile = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1DirectorScore = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1EquifaxScoreAboveThreshold = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1LoanAmount = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1FacilityEstablishmentFeePercent = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1FacilityEstablishmentFee = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1BrokerageDollar = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep1DocFeeFinanced = this.formBuilder.control(null, [Validators.required]);
    if (this.application.ApplicationType === 'AssetFinance') {
      this.formControlStep1LegalName = this.formBuilder.control(null, [Validators.required]);
      this.formControlStep1ABN = this.formBuilder.control(null, [Validators.required]);
      this.formControlStep1ACN = this.formBuilder.control(null);
      this.formControlStep1Address = this.formBuilder.control(null, [Validators.required]);
      this.formControlStep1Email = this.formBuilder.control(null, [Validators.required]);
    } else {
      this.formControlStep1LegalName = this.formBuilder.control(null);
      this.formControlStep1ABN = this.formBuilder.control(null);
      this.formControlStep1ACN = this.formBuilder.control(null);
      this.formControlStep1Address = this.formBuilder.control(null);
      this.formControlStep1Email = this.formBuilder.control(null, [Validators.required]);
    }

    if (this.application.ApplicationType === 'BusinessOverdraft') {
      this.formControlStep1DisplayedMargin = this.formBuilder.control(null, [Validators.required]);
    } else {
      this.formControlStep1DisplayedMargin = this.formBuilder.control(null);
    }

    this.formGroupStep1 = this.formBuilder.group({
      totalInterest: this.formControlStep1TotalInterest,
      invoicePrice: this.formControlStep1InvoicePrice,
      totalPayment: this.formControlStep1TotalPayment,
      paymentInAdvanceOrArrears: this.formControlStep1PaymentInAdvanceOrArrears,
      docFee: this.formControlStep1DocFee,
      interestRate: this.formControlStep1InterestRate,
      margin: this.formControlStep1DisplayedMargin,
      deposit: this.formControlStep1Deposit,
      loanTerm: this.formControlStep1LoanTerm,
      residual: this.formControlStep1Residual,
      repaymentFrequency: this.formControlStep1RepaymentFrequency,
      brokerage: this.formControlStep1BrokerageAmount,
      numberOfInstallment: this.formControlStep1NumberOfInstallment,
      brokerOriginationFee: this.formControlStep1BrokerOriginationFee,
      privateSale: this.formControlStep1PrivateSale,
      transactionType: this.formControlStep1TransactionType,
      repayment: this.formControlStep1Repayment,
      amountFinanced: this.formControlStep1AmountFinanced,
      legalName: this.formControlStep1LegalName,
      abn: this.formControlStep1ABN,
      acn: this.formControlStep1ACN,
      address: this.formControlStep1Address,
      companyEmail: this.formControlStep1Email,
      docFeeFinanced: this.formControlStep1DocFeeFinanced,
    });

    this.formGroupStep1BusinessLoan = this.formBuilder.group({
      loanAmount: this.formControlStep1LoanAmount,
      lowEquifaxScore: this.formControlStep1EquifaxScoreAboveThreshold,
      adverseOnFile: this.formControlStep1AdverseOnFile,
      brokerage: this.formControlStep1BrokerageAmount,
      propertyOwner: this.formControlStep1PropertyOwner,
      loanTerm: this.formControlStep1LoanTerm,
      directorScore: this.formControlStep1DirectorScore,
      docFee: this.formControlStep1DocFee,
      legalName: this.formControlStep1LegalName,
      abn: this.formControlStep1ABN,
      acn: this.formControlStep1ACN,
      address: this.formControlStep1Address,
      companyEmail: this.formControlStep1Email,
    })

    this.formGroupStep1BusinessOverdraft = this.formBuilder.group({
      loanAmount: this.formControlStep1LoanAmount,
      lowEquifaxScore: this.formControlStep1EquifaxScoreAboveThreshold,
      adverseOnFile: this.formControlStep1AdverseOnFile,
      brokerage: this.formControlStep1BrokerageAmount,
      propertyOwner: this.formControlStep1PropertyOwner,
      loanTerm: this.formControlStep1LoanTerm,
      directorScore: this.formControlStep1DirectorScore,
      facilityEstablishmentFeePercent: this.formControlStep1FacilityEstablishmentFeePercent,
      facilityEstablishmentFee: this.formControlStep1FacilityEstablishmentFee,
      brokerageDollar: this.formControlStep1BrokerageDollar,
      legalName: this.formControlStep1LegalName,
      abn: this.formControlStep1ABN,
      acn: this.formControlStep1ACN,
      address: this.formControlStep1Address,
      companyEmail: this.formControlStep1Email,
    })

    if (this.application.ApplicationType === "BusinessLoans") {
      setStepper2StepConfig(this.formGroupStep1BusinessLoan, {
        nextStepClickedFn: async stepper => {
          stepper.next();
        },
        previousStepClickedFn: async (stepper) => {
          this.onClickClose()
        },
        previousStepButtonText:"Close"
      });
    } else if (this.application.ApplicationType === "BusinessOverdraft" ) {
      setStepper2StepConfig(this.formGroupStep1BusinessOverdraft, {
        previousStepButtonText:"Close",
        // brokerage is disabled for brokers, and disabled controls skip validation
        nextStepButtonDisabledFn: () => this.isBrokerageOverMax,
        nextStepClickedFn: async stepper => {
          stepper.next();
        },
        previousStepClickedFn: async (stepper) => {
          this.onClickClose()
        },

      });

    }
    else {
      setStepper2StepConfig(this.formGroupStep1, {
        nextStepClickedFn: async stepper => {
          stepper.next();
        },
        previousStepClickedFn: async (stepper) => {
          this.onClickClose()
        },
        previousStepButtonText:"Close"
      });
    }

    // recalculation
    if (this.application.ApplicationType === "BusinessLoans") {
      this.recalculationForBusinessLoan();
    } else if (this.application.ApplicationType === "BusinessOverdraft" ) {
      this.populateBrokerageForOverdraft()
      this.recalculationForBusinessOverdraft();
    } else {
      this.recalculationForAssetFinance();
    }
  }

  initStep2() {
    this.fromControlStep2CcEmail = this.formBuilder.control(null, Validators.email);
    this.formGroupStep2 = this.formBuilder.group({
      email: this.fromControlStep2CcEmail,
    });

    setStepper2StepConfig(this.formGroupStep2, {
      nextStepClickedFn: async stepper => {
         // check if has a signer or not
      if (!this.checkSignerExistsInIndividuals()) {
        this.applicationDialogService.openAlertDialog({
          message: `Warning`,
          subMessage: `You need to have a signer for generating the contract.`,
        });
        return;
      }

      // check if has select a primary contact or not
      const { checked, primaryContactIndex } = this.getCheckboxResult();
      if (!this.foundPrimaryContactIndividualStep2 && !checked) {
        this.applicationDialogService.openAlertDialog({
          message: `Warning`,
          subMessage: `Please select a primary contact before proceeding to the next step.`,
        });
        return;
      }
      if (primaryContactIndex >= 0) {
        this.primaryContactStep2 = this.allIndividuals[primaryContactIndex];
      }

      // check if all individuals' mobile number are valid
      if (!this.validateIndividualMobileNumbers()) {
        this.applicationDialogService.openAlertDialog({
          message: `Warning`,
          subMessage: `Please make sure the mobile numbers of all signers are valid. You cannot generate a contract using landline numbers.`
        })
        return;
      }

      // if already have a contract, delete it
      this.deleteExistingContract();

      this.subscriptions.push(
        this.generateContractFn({
          signers: this.contractSigners(primaryContactIndex),
          ccs: this.ccEmailListStep2.map(email => { return {
            email: email
          }}),
          templateData: this.templateData,
          applicationType: this.application.ApplicationType,
          financeType: this.application.AppInfo.FinanceType,
          applicationId: this.application.ApplicationId
        }
        ).pipe(
          this.toastService.spinnerObservable(),
        ).subscribe((res: GenerateContractResponse) => {
          this.contractName = res.fileName ?? "";
          this.watermarkedContractName = res.watermarkedFileName ?? "";
          this.contractBase64 = res.base64 ?? "";
          setTimeout(() => {
            this.base64ToArrayBuffer(this.contractBase64);
            stepper.next();
          });
        })
      )
      },
    });



    this.subscriptions.push(
      this.getApplicationIndividualsFn(this.application.ApplicationId).subscribe((result: GetApplicationindividualsPayload) => {
        // including logics for corporate guarantor here
        // If an individual’s role is Others and does not have additional roles, we do not show him/her in the signers’ table.
        // If an individual’s role is Others and does have additional roles, we show him/her in the signers’ table.
        // "Additional roles" here means guarantees: an Others individual earns a place on the
        // contract by signing for a company that guarantees, not by holding any link to any entity.
        this.allIndividuals = result.individuals
          .filter(i => !i.isDeleted
            && !(individualSignerRole(i) === 'Others' && !individualSignedGuaranteeRoles(i).length))
          .map(i => {
            return {
              ...i,
              givenName: removeUnprintableChar(i.givenName ?? '') ?? "",
              surname: removeUnprintableChar(i.surname ?? '') ?? "",
            }
          });
        console.log(this.allIndividuals);
        this.primaryContactCheckbox = this.allIndividuals.map(() => false);
        // The canonical primary signer is the individual already flagged as the primary contact
        // (Contact === 'primaryContact'). Fall back to the resolved applicant/contact matched by a
        // stable id - never by name, which is unreliable (duplicate names, and the row names here
        // are sanitised via removeUnprintableChar while this.primaryContact is not).
        // `guid` when the applicant came from the parties payload, `id` for a Contact: the legacy `id`
        // these rows carry *is* the guid, so both spellings resolve to the same identifier. Matching on
        // the numeric ApplicationIndividual.id instead would compare a number to a string and never hit.
        const primaryContactId = this.primaryContact && 'guid' in this.primaryContact
          ? this.primaryContact.guid
          : (this.primaryContact && 'id' in this.primaryContact ? this.primaryContact.id : undefined);
        let primaryContactIndividualIndex = this.allIndividuals.findIndex(i => i.isPrimaryContact);
        if (primaryContactIndividualIndex < 0 && primaryContactId != null) {
          primaryContactIndividualIndex = this.allIndividuals.findIndex(i => !!i.guid && i.guid === primaryContactId);
        }
        // Guard the -1: only treat a primary as found when a real row was ticked, so the
        // "please select a primary contact" guard correctly fires when none is designated.
        this.foundPrimaryContactIndividualStep2 = primaryContactIndividualIndex >= 0;
        if (primaryContactIndividualIndex >= 0) {
          this.primaryContactCheckbox[primaryContactIndividualIndex] = true;
        }

        this.dataSourceStep2.update(this.allIndividuals);
      })
    )

    this.subscriptions.push(
      this.fromControlStep2CcEmail.valueChanges.subscribe((value: string | null) => {
        if (!value) {
          this.ccEmailListStep2Error = false;
        }
      })
    )
  }

  initStep3() {
    this.formGroupStep3 = this.formBuilder.group({});

    setStepper2StepConfig(this.formGroupStep3, {
      nextStepButtonText:"Send Contract",
      nextStepClickedFn: async stepper => {
         // check if uniqueness of individual email and mobile
      const ok = checkContractIndividuals(this.application, this.applicationDialogService);
      if (ok) {
        // check if has select a primary contact or not
        const { checked, primaryContactIndex } = this.getCheckboxResult();

        // contract email body
        const contractEmailBody: ContractEmailBody = {
          signers: this.contractSigners(primaryContactIndex),
          ccs: this.ccEmailListStep2.map(email => { return {
            email: email
          }}),
          contractName: this.contractName,
          emailSubject: this.emailSubject,
          applicationId: this.application.ApplicationId,
          customerName: getApplicationCustomerName(this.application),
          pricingDetails: this.contractPricingDetails,
          userId: this.loggedInUser?.UserId ?? 0
        }
        if (this.application.ApplicationType === 'AssetFinance') {
          contractEmailBody.assets = this.assets;
          contractEmailBody.loanAmount = (this.formControlStep1InvoicePrice.value ?? 0) - (this.formControlStep1Deposit.value ?? 0);
        }
        this.subscriptions.push(
          this.sendContractEmailsFn(contractEmailBody).pipe(
            this.toastService.spinnerObservable(),
          ).subscribe((response: SendContractResponse) => {
            if (response.success) {
              stepper.next();
            } else {
              if (response.statusCode === 401) {
                this.applicationDialogService.openAlertDialog({
                  message: `Authorization Error`,
                  subMessage: response.error
                });
              }
            }
          })
        )
        this.syncModifiedDetailsToSf();
      }
      },
      showSecondarySubmitButton:true,
      secondaryButtonText:"Preview Contract",
      secondaryButtonClickedFn : async (stepper) => {
        this.downloadContract(this.watermarkedContractName);
      },
    });

  }

  initStep4() {
    this.formGroupStep4 = this.formBuilder.group({});


    setStepper2StepConfig(this.formGroupStep4, {
      nextStepButtonText:"Close",
      nextStepClickedFn: async stepper => {
        this.deleteExistingContract();
        this.dialogRef.close();
      },
      showSecondarySubmitButton:true,
      secondaryButtonText:"Download Contract",
      secondaryButtonClickedFn : async (stepper) => {
        this.downloadContract(this.contractName);
      },
    });

  }

  onClickClose() {
    this.deleteExistingContract();
    this.dialogRef.close()
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (validateEmail(value)) {
      // Add chip
      if (value) {
        this.ccEmailListStep2.push(value);
      }
      // Clear the input value
      event.chipInput!.clear();
      this.ccEmailListStep2Error = false;
    } else if (value) {
      this.ccEmailListStep2Error = true;
    }
  }

  remove(email: string): void {
    const index = this.ccEmailListStep2.indexOf(email);

    if (index >= 0) {
      this.ccEmailListStep2.splice(index, 1);
    }
  }

  onSortData($event: Sort) {

  }

  getApplicationAssets() {
    this.subscriptions.push(
      this.getApplicationAssetFn(this.application.ApplicationId).subscribe((assets: PpsrAsset[]) => {
        this.assets = assets;
        const invoicePrice = this.assets.reduce((partial: number, asset: PpsrAsset) => partial + (asset?.SettlementAssetDetails?.InvoicePrice ?? 0), 0);
        this.invoicePrice = applicationToInvoiceAmount(this.application);
        this.formControlStep1InvoicePrice.setValue(invoicePrice);
        this.formControlStep1InvoicePrice.addValidators(Validators.max((this.invoicePrice ?? 0) * 1.05));


        // validate deposit
        const deposit = applicationToDepositAmount(this.application)
        this.depositValidationMessage = null;
        if (deposit) {
          const {totalDeposit, applicationDeposit, valid} = validateAssetDepositAgainstApplicationDeposit(deposit, assets);
          if (!valid) {
            this.depositValidationMessage = `Application deposit $${applicationDeposit} does not match total asset deposit $${totalDeposit}`;
          }
        }

        if (invoicePrice > (this.invoicePrice ?? 0) * 1.05) {
          console.log(` invoice price (all assets) = ${invoicePrice}, application invoice price ${this.invoicePrice}`);
          this.applicationDialogService.openAlertDialog({
            message: "Warning",
            subMessage: `The invoice amount from all assets is greater than the maximum allowed value. Please contact us on 1300 001 420.`,
          }).afterClosed().subscribe(() => {
            this.dialogRef.close();
          })
        }
      })
    )
  }

  updateNumberOfInstallment(repaymentFrequency: PaymentFrequencyValue | null, loanTerm: LoanTermValue | null) {
    let numberOfInstallment = 0;
    if (repaymentFrequency?.type === "Monthly") {
      numberOfInstallment = Number(loanTerm?.type ?? "0");
    } else if (repaymentFrequency?.type === "Fortnightly") {
      numberOfInstallment = 26 * Number(loanTerm?.type ?? "0") / 12;
    } else if (repaymentFrequency?.type === "Weekly") {
      numberOfInstallment = 52 * Number(loanTerm?.type ?? "0") / 12;
    }
    console.log("numberOfInstallment: ", numberOfInstallment)
    this.formControlStep1NumberOfInstallment.setValue(numberOfInstallment);
  }

  toggleAllSelection() {
    const users = this.dataSourceStep2.subject.getValue();
    for (const user of users) {
      this.selectionStep2.toggle(user);
    }
  }

  onEditAddress() {
    this.subscriptions.push(
      this.applicationDialogService.openEditAddressDialog({
        address: this.formControlStep1Address.value
      }).afterClosed().subscribe((r: EditAddressDialogResult | undefined ) => {
        if (r && r.readyForSubmission) {
          this.formControlStep1Address.setValue(r.address);
        }
      })
    )
  }

  editField(fieldName: "invoicePrice" | "paymentInAdvanceOrArrears" | "interestRate" | "loanTerm" | "docFeeFinanced" | "deposit" |
    "residual" | "repaymentFrequency" | "brokerage" | "brokerOriginationFee" | "loanAmount" | "legalName" | "ABN" | "ACN" | "companyEmail" | "rateDiscount") {
    switch (fieldName) {
      case "invoicePrice":
        if (this.editInvoicePrice) {
          if (this.formControlStep1InvoicePrice.valid) {
            this.editInvoicePrice = !this.editInvoicePrice;
          }
        } else {
          this.editInvoicePrice = !this.editInvoicePrice;
        }
        break;
      case "paymentInAdvanceOrArrears":
        this.editPaymentInAdvanceOrArrears = !this.editPaymentInAdvanceOrArrears;
        break;
      case "interestRate":
        this.editInterestRate = !this.editInterestRate;
        break;
      case "loanTerm":
        this.editLoanTerm = !this.editLoanTerm;
        break;
      case "repaymentFrequency":
        this.editRepaymentFrequency = !this.editRepaymentFrequency;
        break;
      case "brokerage":
        if (this.editBrokerage) {
          const brokerageControl = this.application.ApplicationType === 'BusinessOverdraft'
            ? this.formControlStep1BrokerageDollar
            : this.formControlStep1BrokerageAmount;
          if (brokerageControl.valid) {
            this.editBrokerage = !this.editBrokerage;
          }
        } else {
          this.editBrokerage = !this.editBrokerage;
        }
        break;
      case "brokerOriginationFee":
        if (this.editBrokerOriginationFee) {
          if (this.formControlStep1BrokerOriginationFee.valid) {
            this.editBrokerOriginationFee = !this.editBrokerOriginationFee;
          }
        } else {
          this.editBrokerOriginationFee = !this.editBrokerOriginationFee;
        }
        break;
      case "loanAmount":
        if (this.editLoanAmount) {
          if (this.formControlStep1LoanAmount.valid) {
            this.editLoanAmount = !this.editLoanAmount;
          }
        } else {
          this.editLoanAmount = !this.editLoanAmount;
        }
        break;
      case "legalName":
        if (this.editLegalName) {
          if (this.formControlStep1LegalName.valid) {
            this.editLegalName = !this.editLegalName;
          }
        } else {
          this.editLegalName = !this.editLegalName;
        }
        break;
      case "ABN":
        if (this.editABN) {
          if (this.formControlStep1ABN.valid) {
            this.editABN = !this.editABN;
          }
        } else {
          this.editABN = !this.editABN;
        }
        break;
      case "ACN":
        if (this.editACN) {
          if (this.formControlStep1ACN.valid) {
            this.editACN = !this.editACN;
          }
        } else {
          this.editACN = !this.editACN;
        }
        break;
      case "companyEmail":
        if (this.editEmail) {
          if (this.formControlStep1Email.valid) {
            this.editEmail = !this.editEmail;
          }
        } else {
          this.editEmail = !this.editEmail;
        }
        break;
      case "docFeeFinanced":
        if (this.editDocFeeFinanced) {
          if (this.formControlStep1DocFeeFinanced.valid) {
            this.editDocFeeFinanced = !this.editDocFeeFinanced;
          }
        } else {
          this.editDocFeeFinanced = !this.editDocFeeFinanced;
        }
        break;
      case "deposit":
        if (this.editDeposit) {
          if (this.formControlStep1Deposit.valid) {
            this.editDeposit = !this.editDeposit;
          }
        } else {
          this.editDeposit = !this.editDeposit;
        }
        break;
    }
  }

  get templateData(): ContractTemplateData {
    const repaymentFrequency = this.formControlStep1RepaymentFrequency.value?.type ?? 'Monthly';
    return {
      company: {
        name: this.formControlStep1LegalName.value ?? "",
        abn: this.formControlStep1ABN.value ?? "",
        address: this.formControlStep1Address.value?.address ?? "",
        email: this.primaryContactStep2.email ?? "",
        acn: this.formControlStep1ACN.value ?? "",
        phone: this.primaryContactStep2?.mobileNumber ?? "",
      },
      customer: {
        name: getApplicationName(this.application),
        email: applicantOf(this.application.parties)?.email ?? "",
        mobile: applicantOf(this.application.parties)?.mobileNumber ?? "",
        address: applicantOf(this.application.parties)?.homeAddress?.unformattedAddress ?? "",
      },
      expense: getExpense(this.application),
      invoicePrice: this.formControlStep1InvoicePrice.value ?? 0,
      deposit: this.formControlStep1Deposit.value ?? 0,
      docFeeFinanced: !!this.formControlStep1DocFeeFinanced.value,
      loanAmount: this.application.ApplicationType == 'BusinessLoans' ? this.formControlStep1LoanAmount.value ?? 0 : (this.formControlStep1InvoicePrice.value ?? 0) - (this.formControlStep1Deposit.value ?? 0),
      totalInterest: this.formControlStep1TotalInterest.value ?? 0, //changed this to add brokerage in the field below
      totalInterestInclBrokerage: (this.formControlStep1TotalInterest.value ?? 0) + (this.formControlStep1BrokerageAmount.value ?? 0),
      amountFinanced: this.formControlStep1AmountFinanced.value ?? 0,
      totalAmount: this.formControlStep1TotalPayment.value ?? 0,
      docFee: this.formControlStep1DocFee.value ?? 0,
      numberOfInstallments: this.formControlStep1NumberOfInstallment.value ?? 0,
      repaymentFrequency: repaymentFrequency,
      repaymentFrequencyTypeName: repaymentFrequency.slice(0, repaymentFrequency.length - 2) + "s",
      residual: this.formControlStep1Residual.value ?? 0,
      repayment: this.formControlStep1Repayment.value ?? 0,
      repaymentGST: Math.round((this.formControlStep1Repayment.value ?? 0) * 0.1 * 100) / 100,
      repaymentRaw: this.formControlStep1Repayment.value ?? 0,
      brokerOriginationFee: this.formControlStep1BrokerOriginationFee.value ?? 0,
      term: Number(this.formControlStep1LoanTerm.value?.type ?? '0'),
      rate: this.formControlStep1InterestRate.value ?? 0,
      margin: this.formControlStep1DisplayedMargin.value ?? 0,
      assets: this.assets.map(asset => {
        return {
          description: asset?.SettlementAssetDetails?.description ?? "",
          invoicePrice: asset?.SettlementAssetDetails?.InvoicePrice ?? 0,
          invoiceNumber: String(asset?.invoiceNumber) ?? "",
          supplier: asset?.SettlementAssetDetails?.supplier ?
            (asset.SettlementAssetDetails?.supplier as any)?.SupplierName :
            (parseJSON((asset as any).PrivateSellerDetails)?.business ? parseJSON((asset as any).PrivateSellerDetails)?.business?.organisationName :
              parseJSON((asset as any).PrivateSellerDetails).name + ' ' + parseJSON((asset as any).PrivateSellerDetails).lastName),
          serialNumber: asset?.SettlementAssetDetails?.serialNumber ? (asset?.SettlementAssetDetails?.serialNumberType ?
            asset?.SettlementAssetDetails?.serialNumberType + ": " + asset?.SettlementAssetDetails?.serialNumber :
            "Serial Number: " + asset?.SettlementAssetDetails?.serialNumber) : ""
        }
      }),
      brokerName: getBrokerName(this.application) ?? '',
      // brokerage:  Math.round(getLoanAmount(this.application) * getBrokerage(this.application) / 100 * 100) / 100,
      brokerage: this.currentBrokerageAmount(),
      facilityLimit: this.formControlStep1LoanAmount.value ?? 0,
      facilityEstablishmentFee: this.application.ApplicationType === 'BusinessOverdraft' ? 0 : (this.formControlStep1FacilityEstablishmentFee.value ?? 0),
      paymentInAdvanceOrArrears: this.formControlStep1PaymentInAdvanceOrArrears.value ?? "",
      additionalSecurity: getAdditionalSecurity(this.application),
      specialConditions: getSpecialConditions(this.application),
      transactionType: (this.formControlStep1TransactionType.value?.type) ?? "",
      monthlyAmountKeepingFee: this.rateCard?.MonthlyAccountKeepingFee ?? 0,
      monthlyFacilityFeePercentage: this.rateCard?.FacilityFee ?? 0,
      // commencementDate will be calculated on the backend for BusinessOverdraft limit changes
    }
  }

  deleteExistingContract() {
    if (this.contractName) {
      this.subscriptions.push(
        this.deleteContractFileFn({
          fileName: this.contractName
        }).subscribe()
      )
    }
  }

  downloadContract(fileName: string) {
    const newFileName = getContractFileName(this.application);
    const url = this.apiUrl + "/download-contract/" +  fileName + "/" + newFileName;
    this.subscriptions.push(
      this.httpClient.get<Blob>(url, { ...httpOptions(), responseType: 'blob' as 'json' }).pipe(
        this.toastService.spinnerObservable(),
        this.toastService.publishErrorNotificationObservable({
          errorTitle: 'Contract',
          errorMessage: 'Unable to download the contract',
          retryFn: () => this.downloadContract(fileName),
        }),
      ).subscribe((blob: Blob) => saveAs(blob, newFileName))
    );
  }

  base64ToArrayBuffer(base64: string) {
    let binary_string =  window.atob(base64);
    let len = binary_string.length;
    let bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++)        {
      bytes[i] = binary_string.charCodeAt(i);
    }
    this.contractBuffer = (bytes.buffer as Uint8Array);
  }

  recalculationForAssetFinance() {
    const ac = getAssetCategoryObj(this.application);
    const at = getAssetTypeObj(this.application);
    const assetCategory = getApplicationAssetCategory(this.application); // as string
    const assetType = getAssetType(this.application); // as string
    const assetSelectionValue = applicationToAsset(this.application);


    this.subscriptions.push(
      combineLatest([
        this.getRatecardDetailsFn(this.application.UserId, this.application.ApplicationType),
        this.formControlStep1InvoicePrice.valueChanges,
        this.formControlStep1DocFee.valueChanges,
        this.formControlStep1Deposit.valueChanges,
        this.formControlStep1LoanTerm.valueChanges,
        this.formControlStep1RepaymentFrequency.valueChanges,
        this.formControlStep1BrokerageAmount.valueChanges,
        this.formControlStep1BrokerOriginationFee.valueChanges,
        this.formControlStep1PrivateSale.valueChanges,
        this.formControlStep1DocFeeFinanced.valueChanges,
        this.formControlStep1TransactionType.valueChanges,
      ]).subscribe((
        [rateCard, invoicePrice, docFee, deposit, loanTerm, repaymentFrequency, _brokerageAmount, brokerOriginationFee, privateSale, docFeeFinanced, transactionType]:
          [RatecardDetails, number | null, number | null, number | null, LoanTermValue | null, PaymentFrequencyValue | null,
              number | null, number | null, PrivateSaleType | null, boolean | null, TransactionValue | null]
      ) => {
        this.rateCard = rateCard;
        const date = moment().add(1, 'day');

        // brokerage follows the % when the invoice or deposit changes
        const brokerageAmount = brokerageAmountFromPercent(this.brokeragePercent, this.brokerageLoanAmount());
        if (brokerageAmount !== this.formControlStep1BrokerageAmount.value) {
          this.formControlStep1BrokerageAmount.setValue(brokerageAmount, {emitEvent: false});
        }

        const financialType = this.assetFinanceType();
        const data = {
          paymentFrequencyType: repaymentFrequency?.type as PaymentFrequencyType,
          assetConditionType: getAssetCondition(this.application) as AssetConditionType ?? null,
          assetSelectionValue: assetSelectionValue!,
          assetYear: parseFloat(getAssetYear(this.application) != '' ? getAssetYear(this.application) as any :  "0"),
          loanTerm: numeral(loanTerm?.type).value() ?? 0,
          financeType: financialType,
          //balloonPaymentType: String(getBalloonPaymentPercentage(this.application)) as BalloonPaymentType,
          brokerageType: String(this.brokeragePercent) as BrokerageSelectionType,
          loanAmount: this.assetFinanceLoanAmount(invoicePrice, deposit),
          businessSearchValue: null,
          existingApplicationBureauReport: this.application.CompanyDetails,
          propertyOwnership: yesNoToBoolean(getPropertyOwner(this.application)),
          docFeeFinanced: !!docFeeFinanced,
          brokerOriginationFee: brokerOriginationFee as number,
          brokerage: this.brokeragePercent,
          adverseOnFile: yesNoToBoolean(getAdverseOnFile(this.application)),
          equifaxDirectorScoreMeetsProductThreshold: yesNoToBoolean(getEquifaxScoreAboveThresold(this.application)),
          equifaxDirectorScoreAbove700: applicationToEquifaxDirectorScoreMeetsThreshold(this.application, '>=700'),
          privateSaleOrLeaseback: privateSale !== 'No',
          balloonPayment: getBalloonPaymentPercentage(this.application),
          rateCard: rateCard,
          invoiceAmount: Number(invoicePrice),
          brokerageAmount: brokerageAmount,
          deposit: Number(deposit),
          // ADO 1752: balloonPaymentAmount is deliberately omitted so the calculator recomputes the
          // residual from the balloon percentage against the current invoice, not the approved one.
          creditRateAdjustment: getCreditRateAdjustment(this.application),
          transactionType: transactionType?.type,
          repaymentType: getRepaymentType(this.application) ?? '',
          abnAgeAboveThresholdOverride: applicationToAbnAgeAboveThresholdOverride(this.application)
        };

        const rst = calculateAssetFinanceEstimation(date, {
          type: 'AssetFinance',
          ...data,
          paymentType: String(getPaymentType(this.application)),
          docFee: getDocFee(this.application) as number,
        });

        const paymentChartData = rst.totalPaymentBreakupDialogData.paymentChartData;
        console.log(paymentChartData)
        this.formControlStep1AmountFinanced.setValue(paymentChartData.amountFinanced);
        this.formControlStep1Repayment.setValue(paymentChartData.emiAmt);
        this.formControlStep1TotalInterest.setValue(paymentChartData.interestAmt);
        this.formControlStep1TotalPayment.setValue(paymentChartData.totalAmt);
        this.formControlStep1Residual.setValue(paymentChartData.rv);
        this.formControlStep1InterestRate.setValue(Math.round(paymentChartData.totalInterest * 100) / 100);
        this.updateNumberOfInstallment(repaymentFrequency, loanTerm);
      })
    )
  }

  private assetFinanceType(): FinanceType {
    return (getFinanceType(this.application) as string).toLowerCase().split(' ').join('-') as FinanceType;
  }

  /** Asset Finance: current invoice - deposit; Business Loan: loan amount; Overdraft: facility limit. */
  private brokerageLoanAmount(): number {
    if (this.application.ApplicationType === 'AssetFinance' && this.formControlStep1InvoicePrice.value) {
      return assetFinanceBrokerageBasis(
        this.formControlStep1InvoicePrice.value,
        this.formControlStep1Deposit.value ?? 0,
        this.assetFinanceType() === 'rental',
      );
    }
    return this.loanAmount;
  }

  private currentBrokerageAmount(): number {
    const control = this.application.ApplicationType === 'BusinessOverdraft'
      ? this.formControlStep1BrokerageDollar
      : this.formControlStep1BrokerageAmount;
    return control.value ?? 0;
  }

  private brokerageMaxValidator: ValidatorFn = (control) => {
    const basis = this.brokerageLoanAmount();
    return brokerageExceedsMax(this.application.ApplicationType, control.value ?? 0, basis, this.application.CreateTime)
      ? {max: {max: maxBrokerageAmount(this.application.ApplicationType, basis, this.application.CreateTime)}}
      : null;
  }

  get brokeragePercentOfLoan(): number {
    const basis = this.brokerageLoanAmount();
    return basis ? this.currentBrokerageAmount() * 100 / basis : 0;
  }

  get isBrokerageOverMax(): boolean {
    return brokerageExceedsMax(this.application.ApplicationType, this.currentBrokerageAmount(), this.brokerageLoanAmount(), this.application.CreateTime);
  }

  get brokerageOverMaxMessage(): string {
    const message = brokerageExceedsMaxMessage(this.application.ApplicationType, this.currentBrokerageAmount(), this.brokerageLoanAmount(), this.application.CreateTime);
    return this.application.ApplicationType === 'BusinessOverdraft' && !this.canEditOverdraftBrokerageOnContract
      ? `${message}. Please contact us to reduce it.`
      : message;
  }

  onEditBrokerage() {
    this.subscriptions.push(
      this.applicationDialogService.openEditBrokerageDailog({
        brokerageAmount: this.formControlStep1BrokerageAmount.value ?? 0,
        loanAmount: this.brokerageLoanAmount(),
        maxBrokeragePercentage: maxBrokeragePercent(this.application.ApplicationType, this.application.CreateTime) ?? undefined,
        warningBrokeragePercentage: this.application.ApplicationType === 'AssetFinance' ? ASSET_FINANCE_BROKERAGE_UPLIFT_TIER1_PERCENT : undefined,
      }).afterClosed().subscribe((r: EditBrokerageDialogResult | undefined) => {
        if (r?.readyForSubmission) {
          const loanAmount = this.brokerageLoanAmount();
          this.brokeragePercent = loanAmount ? r.brokerageAmount * 100 / loanAmount : 0;
          this.formControlStep1BrokerageAmount.setValue(r.brokerageAmount);
        }
      })
    );
  }

  recalculationForBusinessLoan() {
    this.subscriptions.push(
      combineLatest([
        this.getRatecardDetailsFn(this.application.UserId,  this.application.ApplicationType),
        this.formControlStep1RepaymentFrequency.valueChanges,
        this.formControlStep1LoanTerm.valueChanges,
        this.formControlStep1BrokerageAmount.valueChanges,
        this.formControlStep1LoanAmount.valueChanges,
        this.formControlStep1DocFeeFinanced.valueChanges
      ]).subscribe(([rateCard, repaymentFrequency, loanTerm, brokerageAmount, loanAmount, docFeeFinanced]: [
        RatecardDetails, PaymentFrequencyValue | null,  LoanTermValue | null, number | null, number | null, boolean | null
      ]) => {
        this.rateCard = rateCard;
        const date = moment().add(1, 'day');
        const equifaxDirectorScoreAbove700BL = applicationToEquifaxDirectorScoreMeetsThreshold(this.application, '>=700');
        const rst = calculateBusinessLoanEstimation(date, {
          type: 'BusinessLoans',
          paymentFrequencyType: repaymentFrequency?.type as PaymentFrequencyType,
          loanTermType: loanTerm?.type as LoanTermType,
          brokerageType: String(loanAmount ? (brokerageAmount ?? 0) * 100 / loanAmount : 0) as BrokerageSelectionType,
          loanAmount: loanAmount ?? 0,
          businessSearchValue: null,
          bureauReport: this.application.CompanyDetails,
          equifaxDirectorScoreAbove700: equifaxDirectorScoreAbove700BL,
          gstAgeMonths: applicationToGstAgeMonths(this.application),
          gstAgeMonthsWithContinuity: applicationToGstAgeMonthsWithContinuity(this.application),
          propertyOwner: yesNoToBoolean(getPropertyOwner(this.application)),
          adverseOnFile: yesNoToBoolean(getAdverseOnFile(this.application)),
          rateCard: rateCard,
          brokerageAmount: brokerageAmount ?? 0,
          docFee: getDocFee(this.application) as number,
          docFeeFinanced: !!docFeeFinanced,
          paymentType: String(getPaymentType(this.application)),
          creditRateAdjustment: getCreditRateAdjustment(this.application),
          abnAgeAboveThresholdOverride: applicationToAbnAgeAboveThresholdOverride(this.application),
        })

        const paymentChartData = rst.totalPaymentBreakupDialogData.paymentChartData;
        console.log(paymentChartData);
        this.formControlStep1InterestRate.setValue(Math.round(paymentChartData.totalInterest * 100) / 100);
        this.formControlStep1AmountFinanced.setValue(paymentChartData.amountFinanced);
        this.formControlStep1Repayment.setValue(paymentChartData.emiAmt);
        this.formControlStep1TotalInterest.setValue(paymentChartData.interestAmt);
        this.formControlStep1TotalPayment.setValue(paymentChartData.totalAmt);
        this.updateNumberOfInstallment(repaymentFrequency, loanTerm);
      })
    )
  }

  recalculationForBusinessOverdraft() {
    this.subscriptions.push(
      combineLatest([
        this.getRatecardDetailsFn(this.application.UserId,  this.application.ApplicationType),
        this.formControlStep1LoanTerm.valueChanges,
        this.formControlStep1LoanAmount.valueChanges,
        this.formControlStep1BrokerageDollar.valueChanges,
      ]).subscribe(([rateCard, loanTerm, loanAmount, brokerageAmount]: [
        RatecardDetails, LoanTermValue | null, number | null, number | null
      ]) => {
        this.rateCard = rateCard;
        const date = moment().add(1, 'day');
        const equifaxDirectorScoreAbove700OD = applicationToEquifaxDirectorScoreMeetsThreshold(this.application, '>=700');
        const rst: CalculateBusinessOverdraftEstimationResult = calculateBusinessOverdraftFees(date, {
          type: 'BusinessOverdraft',
          loanTermType: loanTerm?.type as LoanTermType,
          equifaxDirectorScoreAbove700: equifaxDirectorScoreAbove700OD,
          gstAgeMonths: applicationToGstAgeMonths(this.application),
          gstAgeMonthsWithContinuity: applicationToGstAgeMonthsWithContinuity(this.application),
          propertyOwner: yesNoToBoolean(getPropertyOwner(this.application)),
          adverseOnFile: yesNoToBoolean(getAdverseOnFile(this.application)),
          rateCard: rateCard,
          facilityLimit: loanAmount ?? 0,
          brokerageAmount: brokerageAmount ?? 0,
          docFee: getDocFee(this.application) as number,
          creditRateAdjustment: getCreditRateAdjustment(this.application),
          loanPurpose: (this.application as any).AppInfo?.LoanPurpose ?? null,
          termRenewal: applicationToTermRenewal(this.application),
          additionalCommission: applicationToAdditionalCommission(this.application),
        });
        this.formControlStep1InterestRate.setValue(Math.round(rst.term.interestRate * 100) / 100);
        this.formControlStep1DisplayedMargin.setValue(Math.round(100 * (rst.term.interestRate - getRbaRate(this.application))) / 100);
        // Facility Establishment Fee is no longer part of BO pricing; contract uses 0.
        this.formControlStep1FacilityEstablishmentFee.setValue(0);
        this.formControlStep1DocFee.setValue(rst.term.docFee);
        this.formControlStep1Repayment.setValue(rst.term.monthlyFacilityFee);
        this.formControlStep1AmountFinanced.setValue(rst.term.amountAvailable);
        this.updateNumberOfInstallment(this.formControlStep1RepaymentFrequency.value, loanTerm);
      })
    )
  }

  populateBrokerageForOverdraft() {
    const app = this.application as any;
    const savedBrokerage = app.PricingDetails?.BrokerageAmount ?? app.PricingDetails?.BrokerageDollar ?? 0;

    this.formControlStep1BrokerageDollar.setValue(savedBrokerage);
    if (!this.canEditOverdraftBrokerageOnContract) {
      this.formControlStep1BrokerageDollar.disable();
    }
    
    // Get the maximum allowed brokerage for validation purposes only
    this.subscriptions.push(
      this.getRatecardDetailsFn(this.application.UserId,  this.application.ApplicationType).subscribe(rateCard => {
        const date = moment().add(1, 'day');
        const loanTerm = this.formControlStep1LoanTerm.value;
        const loanAmount = this.formControlStep1LoanAmount.value;
        const equifaxDirectorScoreAbove700ODBrokerage = applicationToEquifaxDirectorScoreMeetsThreshold(this.application, '>=700');
        const rst: CalculateBusinessOverdraftEstimationResult = calculateBusinessOverdraftFees(date, {
          type: 'BusinessOverdraft',
          loanTermType: loanTerm?.type as LoanTermType,
          equifaxDirectorScoreAbove700: equifaxDirectorScoreAbove700ODBrokerage,
          gstAgeMonths: applicationToGstAgeMonths(this.application),
          gstAgeMonthsWithContinuity: applicationToGstAgeMonthsWithContinuity(this.application),
          propertyOwner: yesNoToBoolean(getPropertyOwner(this.application)),
          adverseOnFile: yesNoToBoolean(getAdverseOnFile(this.application)),
          rateCard: rateCard,
          facilityLimit: loanAmount ?? 0,
          docFee: getDocFee(this.application) as number,
          creditRateAdjustment: getCreditRateAdjustment(this.application),
          loanPurpose: (this.application as any).AppInfo?.LoanPurpose ?? null,
          termRenewal: applicationToTermRenewal(this.application),
          additionalCommission: applicationToAdditionalCommission(this.application),
        });
        // Only use the calculated value for validation max, not to set the actual value
        this.formControlStep1BrokerageDollar.clearValidators();
        this.formControlStep1BrokerageDollar.setValidators([Validators.required, Validators.max(rst.term.brokerageDollar), this.brokerageMaxValidator]);
        this.formControlStep1BrokerageDollar.updateValueAndValidity();
      })
    )
  }

  onChangeCheckbox(event: MatCheckboxChange, index: number) {
    console.log(event);
    if (event.checked) {
      this.primaryContactCheckbox[index] = true;
      for (let i = 0; i < this.primaryContactCheckbox.length; i++) {
        if (i !== index) {
          this.primaryContactCheckbox[i] = false;
        }
      }
    }
  }

  // Rental deposits are GST-inclusive, so only the ex-GST part comes off the invoice.
  private assetFinanceLoanAmount(invoicePrice: number | null, deposit: number | null): number {
    const financeType = String(getFinanceType(this.application) ?? '').toLowerCase().split(' ').join('-');
    return financeType === 'rental'
      ? Math.round(100 * (Number(invoicePrice) - Number(deposit) * 10 / 11)) / 100
      : Number(invoicePrice) - Number(deposit);
  }

  private getCheckboxResult(): { checked: boolean, primaryContactIndex: number } {
    let primaryContactIndex = -1;
    let checked = false;
    for (let i = 0; i < this.primaryContactCheckbox.length; i++) {
      if (this.primaryContactCheckbox[i]) {
        checked = true;
        primaryContactIndex = i;
        break;
      }
    }
    return {
      checked,
      primaryContactIndex
    }
  }

  private checkSignerExistsInIndividuals(): boolean {
    for (const individual of this.allIndividuals) {
      const signerRole = individualSignerRole(individual);
      if (signerRole === "Signer" || signerRole === "GuarantorSigner") {
        return true;
      }
    }
    return false;
  }

  private contractSigners(primaryContactIndex: number): DocusignSigner[] {
    return this.allIndividuals.map((individual, index) => ({
      individualId: individual.guid ?? '',
      email: individual.email ?? "",
      name: individual.givenName + " " + individual.surname,
      role: individualSignerRole(individual) as string,
      mobile: individual.mobileNumber ?? "",
      address: individual.homeAddress?.unformattedAddress ?? "",
      isPrimaryContact: index === primaryContactIndex,
      // Always was "": thirdPartyEntity sat on the merged IndividualWithResult declaration but
      // nothing on the read path ever populated it (AZ-1475). The wire field stays - the legal
      // templates reference it - but the dead input branch goes.
      thirdPartyEntity: "",
      // Guarantees only: these become the corporate-guarantor clauses in the contract, so a
      // link to an entity that guarantees nothing - a shareholding in the corporate trustee -
      // must not appear among them.
      additionalRoles: individualSignedGuaranteeRoles(individual),
    }));
  }

  private validateIndividualMobileNumbers(): boolean {
    for (const individual of this.allIndividuals) {
      if (!(individual.mobileNumber ?? '').startsWith('04')) {
        return false;
      }
    }
    return true;
  }

  get emailSubject(): string {
    if (this.application.ApplicationType === "BusinessLoans") {
      return `Dynamoney Term Loan Agreement - ${this.application.BrokerAppId} Dated ${moment().format("hh-mm A DD-MM-YYYY")}`;
    } else if (this.application.ApplicationType === "BusinessOverdraft") {
      return `Dynamoney Overdraft Loan Agreement - ${this.application.BrokerAppId} Dated ${moment().format("hh-mm A DD-MM-YYYY")}`;
    } else if (this.application.ApplicationType === "AssetFinance") {
      if (this.application.AppInfo.FinanceType === "Chattel Mortgage") {
        return `Dynamoney Secured Loan Agreement - ${this.application.BrokerAppId} Dated ${moment().format("hh-mm A DD-MM-YYYY")}`;
      } else if (this.application.AppInfo.FinanceType === "Rental") {
        return `Dynamoney Rental Agreement - ${this.application.BrokerAppId} Dated ${moment().format("hh-mm A DD-MM-YYYY")}`;
      }
    }

    return "";
  }

  syncModifiedDetailsToSf() {
    let invoiceAmount = this.formControlStep1InvoicePrice.value ?? 0;
    if (this.application.ApplicationType === 'BusinessLoans' || this.application.ApplicationType === 'BusinessOverdraft') {
      invoiceAmount = this.formControlStep1LoanAmount.value ?? 0;
    }

    let body: SyncContractDetailsBody = {
      brokerageAmount: this.formControlStep1BrokerageAmount.value ?? 0,
      brokerOriginationFee: this.formControlStep1BrokerOriginationFee.value ?? 0,
      invoiceAmount: invoiceAmount,
      salesforceId: getAppSalesforceId(this.application) ?? '',
      applicationId: this.application.ApplicationId,
      brokerageDollar: this.formControlStep1BrokerageAmount.value ?? 0,
    };
    if (this.application.ApplicationType === 'AssetFinance') {
      body = {
        ...body,
        legalName: this.formControlStep1LegalName.value ?? '',
        address: this.formControlStep1Address.value?.address ?? '',
        abn: this.formControlStep1ABN.value ?? '',
        acn: this.formControlStep1ACN.value ?? '',
        docFeeFinanced: !!this.formControlStep1DocFeeFinanced.value,
      }
    }
    if (this.application.ApplicationType === 'BusinessOverdraft') {
      body = {
        ...body,
        facilityEstablishmentFee: this.formControlStep1FacilityEstablishmentFee.value ?? 0,
        docFeeFinanced: !!this.formControlStep1DocFeeFinanced.value,
      }
    }

    this.subscriptions.push(
      this.syncContractDetailsToSfFn(body).subscribe()
    )
  }

  get contractPricingDetails(): ContractPricingDetails {
    let contractPricingDetails: ContractPricingDetails = {};
    if (this.application.ApplicationType === 'AssetFinance') {
      const invoiceAmount = this.formControlStep1InvoicePrice.value ?? 0;
      const deposit = this.formControlStep1Deposit.value ?? 0;
      const loanAmount = invoiceAmount - deposit;
      const balloonPayment = this.formControlStep1Residual.value ?? 0;
      const brokerageAmount = this.formControlStep1BrokerageAmount.value ?? 0;
      contractPricingDetails = {
          InvoiceAmount: invoiceAmount,
          Deposit: deposit,
          LoanAmount: loanAmount,
          AmountFinance: this.formControlStep1AmountFinanced.value ?? 0,
          // ADO 1752: the balloon percentage is of the invoice, not of Invoice − Deposit. Snapshotting
          // on the loan basis wrote an inflated percentage back onto PricingDetails, which then fell
          // outside the fixed options the pricing tab offers. Send the dollar amount too so the
          // merge does not have to re-derive it.
          BalloonPaymentPercentage: invoiceAmount ? Math.round(Number(balloonPayment * 100 / invoiceAmount) * 100) / 100 : 0,
          BalloonPayment: balloonPayment,
          Repayment: this.formControlStep1Repayment.value ?? 0,
          BrokerageAmount: brokerageAmount,
          Brokerage: Math.round(brokerageAmount * 100 * 100 / loanAmount) / 100,
          BrokerOriginationFee: this.formControlStep1BrokerOriginationFee.value ?? 0,
          DocFeeFinanced: booleanToYesNo(this.formControlStep1DocFeeFinanced.value),
          Rate: this.formControlStep1InterestRate.value ?? 0,
      };
    } else if (this.application.ApplicationType === 'BusinessLoans') {
      const loanAmount = this.formControlStep1LoanAmount.value ?? 0;
      const brokerageAmount = this.formControlStep1BrokerageAmount.value ?? 0;
      contractPricingDetails = {
        LoanAmount: loanAmount,
        Repayment: this.formControlStep1Repayment.value ?? 0,
        BrokerageAmount: brokerageAmount,
        BrokerOriginationFee: this.formControlStep1BrokerOriginationFee.value ?? 0,
        Rate: this.formControlStep1InterestRate.value ?? 0,
        DocFeeFinanced: booleanToYesNo(this.formControlStep1DocFeeFinanced.value),
      };
    } else if (this.application.ApplicationType === 'BusinessOverdraft') {
      const loanAmount = this.formControlStep1LoanAmount.value ?? 0;
      const brokerageAmount = this.formControlStep1BrokerageDollar.value ?? 0;
      contractPricingDetails = {
        LoanAmount: loanAmount,
        BrokerageAmount: brokerageAmount,
        BrokerageDollar: brokerageAmount,
        FacilityEstablishmentFee: this.formControlStep1FacilityEstablishmentFee.value ?? 0,
        Rate: this.formControlStep1InterestRate.value ?? 0,
        Margin: this.formControlStep1DisplayedMargin.value ?? 0,
      }
    }


    return contractPricingDetails;
  }
}
